var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebugLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    stroke: "#545454",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m08p8kdgma)",
    stroke: "{stroke}",
    strokeWidth: 1.333
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.333.667H1.999A1.333 1.333 0 0 0 .666 2v10.667A1.333 1.333 0 0 0 1.999 14h4M7.333.667l4 4h-4v-4zM4.666 8H3.333m1.333 2.667H3.333m1.333-5.333H3.333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.333v2c0 .44-.122.852-.333 1.203M14 10.333l1.333.667M14 10.333c0-.93-.545-1.734-1.333-2.108m-3.334 2.108v2c0 .636.255 1.213.667 1.633m-.667-3.633L8 11m1.333-.667c0-.93.545-1.734 1.334-2.108m2 0a2.325 2.325 0 0 0-1-.225c-.358 0-.697.08-1 .225m2 0L13.333 7m-2.666 1.225L9.667 7m4 6.536a2.332 2.332 0 0 1-3.667.43m3.667-.43L15 14.666m-5-.7L8.333 15",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10.667h1.667m1.666 0h-1.666m0 0v3.667"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m08p8kdgma"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebugLog);
export default __webpack_public_path__ + "static/media/debugLog.2a82d9015e2bf8db780022aeacd07f88.svg";
export { ForwardRef as ReactComponent };